import styled from 'styled-components'
import tw from 'twin.macro'

export const AppButtonSelectWrapper = styled.div`
  ${tw`flex flex-row py-2 bg-app-white-10 `}
`
export const AppButtonSelectOptionContainer = styled.div`
  ${tw`flex items-center py-[10px] pr-4 cursor-pointer rounded-lg`}
`
